import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import Modal from "components/Modal/Modal";
import { toast } from "react-toastify";
import {
  deleteBuilding,
  deleteSalesUnit,
  selectBuildingForDeletion,
  selectSalesUnitForDeletion,
  selectState,
  setDeleteBuildingModalOpen,
} from "../main.slice";

const DeleteBuildingModal = () => {
  const { deleteItemModalOpen } = useSelector(selectState);
  const building = useSelector(selectBuildingForDeletion);
  const salesUnit = useSelector(selectSalesUnitForDeletion)
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setDeleteBuildingModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      if (building) {
        await dispatch(deleteBuilding(building.building.buildingId)).unwrap();
      }
      if (salesUnit) {
        await dispatch(deleteSalesUnit(salesUnit)).unwrap();
      }
      toast.success("Uspesno obrisan.");
      close();
    } catch (err) {
      toast.warn("Nije uspelo brisanje stavke. Obratite se podršci.")
    }
  };

  return (
    <Modal
      isOpen={deleteItemModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje projekta"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledeći projekat:
        <br />
        <br />
        <b>{building ? building.building?.fullName : salesUnit?.fullName} ?</b>
      </p>
    </Modal>
  );
};

export default DeleteBuildingModal;
